// extracted by mini-css-extract-plugin
module.exports = {"headerContent":"actual-header_headerContent__eYyPV","title":"actual-header_title__aE__J"};